import React from 'react';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';

const WidgetCard = ({ title, subtitle, action, children, testId }) => (
  <Card variant="outlined" sx={{ height: '100%' }} data-testid={testId}>
    <CardHeader title={title} subheader={subtitle} action={action} />
    <CardContent>
      {children}
    </CardContent>
  </Card>
);

const WidgetEmptyState = ({ message }) => (
  <Typography variant="body2" color="text.secondary">
    {message}
  </Typography>
);

export { WidgetCard, WidgetEmptyState };
